import { gql } from '@apollo/client';

export const NBJ_COMPOSE_PAGES_FRAGMENT = gql`
  fragment NBJComposePagesFragment on NBJComposePages {
    title
    slug
    cartUrl
    seoMetadata {
      fields {
        urlSlug
        seoTitle
        description
        keywords
      }
    }
    contentList {
      fields {
        contentModelType
        classNameReference
      }
      sys {
        id
        contentType {
          sys {
            id
          }
        }
      }
    }
    subMenu {
      fields {
        navigationItem {
          fields {
            itemUrl
          }
        }
        menuSections {
          fields {
            sectionName
            sectionLinks {
              fields {
                name
                itemUrl
              }
            }
          }
        }
      }
    }
  }
`;

export const MEDIA_FRAGMENT = gql`
  fragment MediaFragment on MediaContentDetails {
    fields {
      title
      description
      file
    }
    sys {
      id
    }
  }
`;

export const CHANNEL_SET_FIELDS = `
   fields {
      title
      detailInformation
      images {
        ...MediaFragment
      }
    }
   sys {
    id
   }
`;

export const PRODUCT_FEATURES = `
    fields {
      members {
        fields {
            first_image{
                        fields{
                            title
                            icon{
                                ...MediaFragment
                            }
                        }
                    }
          smallDescription
          desciption
          ctaButtonImage {
           ...MediaFragment
           }
          ctaLink
        }
        sys {
          id
        }
      }
    }
    sys {
      id
    }   
`;

export const PRODUCT_INFO = `
fields{
title
infoTitle
titleImage {
  ...MediaFragment
}
bottomTitle
 members {
        fields {
             first_image{
                        fields{
                            title
                            icon{
                                ...MediaFragment
                            }
                        }
                    }
 
          desciption
          smallDescription
          ctaButtonImage {
           ...MediaFragment
           }
          ctaLink
        }
      }
}
`;
export const TERMS_AND_CONDITIONS = `
 fields {
 bgTitle
 isExpandable
 terms
}
`;

export const CTA_BUTTON_GROUP_FIELDS = `
  ctaButtonOneText
  ctaButtonOneLink
  ctaButtonOneColorVariant
  ctaButtonTwoText
  ctaButtonTwoLink
  ctaButtonTwoColorVariant
  ctaMoreInfoText
  ctaMoreInfoColorVariant
  ctaMoreInfoImage {
    ...MediaFragment
  }
`;

export const PLAN_DETAILS = `
    internalName
    title
    shortTitle
    titleForBanner
    type
    categories
    subCategories
    lozengeText
    recomonded
    lozengeBackgroundImage {
      ...MediaFragment
    }
    description
    shortDescription
    longDescription
    smallThumbnail {
      ...MediaFragment
    }
    thumbnail {
      ...MediaFragment
    }
    largeThumbnail {
      ...MediaFragment
    }
    tileImages {
      ...MediaFragment
    }
    titleImageMobile {
      ...MediaFragment
    }
    titleImageDesktop {
      ...MediaFragment
    }
    productSku
    productKkInfo
    productInfo {
     ${PRODUCT_INFO}
    }
    price
    discountedPrice
    priceFrequencyType
    ctaMoreInfoText
    ctaMoreInfoColorVariant
    ctaMoreInfoImage{
      ...MediaFragment
    }
    ctaMoreInfoLink
    ctaButtonOneText
    ctaButtonOneLink
    ctaButtonOneColorVariant
    ctaButtonTwoColorVariant,
    ctaButtonTwoLink,
    ctaButtonTwoText
    ctaButtonThreeText
    ctaButtonThreeLink
    ctaButtonThreeColorVariant
    channelSet {
       ${CHANNEL_SET_FIELDS}
    }
    productFeatures {
      ${PRODUCT_FEATURES}
    }
    infoList
    teamCondition {
    ${TERMS_AND_CONDITIONS}
    }
    productInfoDescription
    bulletImage {
      ...MediaFragment
    }
    bulletInfoImage {
      ...MediaFragment
    }
    discountLozengeBackgroundImage {
      ...MediaFragment
    }
    discountLozengeText
    recommendationImage {
      ...MediaFragment
    }
    legalLine
    termsAndConditionsCaption
    uploadDataSpeed
    downloadDataSpeed
    tvSpeedImage
    broadbandSpeedTitle
    broadbandSpeedDescription
    name
    moreDetails
    wifiUnlimitedImage {
    ...MediaFragment
    }`;

export const PRODUCT_GROUP = `
  members {
    fields {
      name
      ${PLAN_DETAILS} 
    }
    sys {
      id
    }
  }
`;
export const FAQS_LIST_FRAGMENT = gql`
  fragment FaqListFragment on FaqsListDetails {
    fields {
      question
      answer
    }
    sys {
      id
    }
  }
`;

export const COMPONENT_STYLES_FRAGMENT = `
  sectionTopPadding
  sectionBottomPadding
`;

export const QUICK_PRODUCT_GROUP = `
internalName
  name
  title
  shortTitle
  lozengeText
  legalLine
  termsAndConditionsCaption
  recomonded
  price
  discountedPrice
  priceFrequencyType
  uploadDataSpeed
  downloadDataSpeed
  tvSpeedImage
  titleImageMobile {
    ...MediaFragment
  }
  broadbandSpeedTitle
  broadbandSpeedDescription
`;
